import { isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta03ExemplosEnum,
  ConsultaSeguimentoPergunta03Model,
} from './model-consultaSeguimentoPergunta03'

const pergunta03ExemplosEnumValues = Object.values(ConsultaSeguimentoPergunta03ExemplosEnum)

export const isPergunta03ExemplosAllNao = (
  value: ConsultaSeguimentoPergunta03Model['PERGUNTA_03_EXEMPLOS']
): boolean => {
  return isAllNao(value, pergunta03ExemplosEnumValues)
}
